import { render, staticRenderFns } from "./SuperAcademy.vue?vue&type=template&id=70277028"
import script from "./SuperAcademy.vue?vue&type=script&lang=js"
export * from "./SuperAcademy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports